import script from "./PayMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./PayMessage.vue?vue&type=script&setup=true&lang=js"

import "./PayMessage.vue?vue&type=style&index=0&id=c8e4fc5c&scoped=true&lang=less"
import "./PayMessage.vue?vue&type=style&index=1&id=c8e4fc5c&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8e4fc5c"]])

export default __exports__